import { toast } from 'react-toastify';

const INITIAL_STATE = {
  todos: [],
  aguardando: [],
  arquivados: [],
  inserir: [],
  configurado: [],
  configurar: [],
  processando: [],
  finalizados: [],
  pagIndividual: [],
  vencidos: [],
  quaseVencidos: [],
  especifico: {
    dono: { nome: "" },
    formandos: [],
    itens: []
  },
  qtdNovos: 0,
  qtdConfigurados: 0,
  qtdProcessando: 0,
  qtdFinalizados: 0,
  carregando: false,
  erro: null,
  ultimo: null,
  confirmarPlanilha: false,
  planilhaComprasDistribuida: false,
};

let contratos = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'REQUISITAR_CONTRATO':
      return { ...state, carregando: true };
    case 'ERRO_CONTRATO':
      toast.error(action.erro.message, 5000);
      return { ...state, carregando: false, erro: action.erro };
    case 'COUNT_CONTRATOS_NOVOS':
      return { ...state, carregando: false, qtdNovos: action.qtd };
    case 'COUNT_CONTRATOS_CONFIGURADO':
      return { ...state, carregando: false, qtdConfigurados: action.qtd };
    case 'COUNT_CONTRATOS_PROCESSANDO':
      return { ...state, carregando: false, qtdProcessando: action.qtd };
    case 'COUNT_CONTRATOS_FINALIZADOS':
      return { ...state, carregando: false, qtdFinalizados: action.qtd };
    case 'OBTER_CONTRATOS_INSERIR':
      return { ...state, carregando: false, inserir: action.contratos };
    case 'OBTER_TODOS_CONTRATOS':
      return { ...state, carregando: false, todos: action.contratos };
    case 'OBTER_TODOS_C_AGUARDANDO':
      return { ...state, carregando: false, aguardando: action.contratos };
    case 'OBTER_TODOS_C_CADASTRADO':
      return { ...state, carregando: false, cadastrados: action.contratos };
    case 'OBTER_TODOS_C_ARQUIVADOS':
      return { ...state, carregando: false, arquivados: action.contratos };
    case 'OBTER_TODOS_C_CONFIGURADO':
      return { ...state, carregando: false, configurado: action.contratos };
    case 'OBTER_TODOS_C_PAGAMENTO_INDIVIDUAL':
      return { ...state, carregando: false, pagIndividual: action.contratos };
    case 'OBTER_TODOS_C_CONFIGURAR':
      return { ...state, carregando: false, configurar: action.contratos };
    case 'OBTER_TODOS_C_PROCESSANDO':
      return { ...state, carregando: false, processando: action.contratos };
    case 'OBTER_TODOS_C_FINALIZADOS':
      return { ...state, carregando: false, finalizados: action.contratos };
    case 'OBTER_ESPECIFICO':
      return { ...state, carregando: false, especifico: action.contrato };
    case 'OBTER_VENCIDOS':
      return { ...state, carregando: false, vencidos: action.contratos };
    case 'OBTER_QUASE_VENCIDOS':
      return { ...state, carregando: false, quaseVencidos: action.contratos };
    case 'NOVO_CONTRATO':
      return { ...state, carregando: false, todos: state.todos.concat(action.contrato), ultimo: action.contrato };
    case 'COMPRAS_COMISSAO_DISTRIBUIDAS':
      contratos = state.todos;
      for (let i = 0; i < contratos.length; i++) {
        if (contratos[i].id === action.contratoId) {
          contratos[i].distribuiuItens = action.status;
        }
      }
      return { ...state, planilhaComprasDistribuida: action.status, todos: contratos };
    case 'ESTORNO_PLANILHA_QUANTIDADES':
      let contratosTemp = state.todos;
      if (action.extornada) {
        for (let i = 0; i < contratosTemp.length; i++) {
          if (contratosTemp[i].id === action.contratoId) {
            contratosTemp[i].distribuiuItens = false;
            contratosTemp[i].dtAprPlanilha = null;
          }
        }
      }
      return { ...state, todos: contratosTemp };
    case 'STATUS_DIST_BRINDES':
      let contratosDistBrindes = state.todos;
      for (let i = 0; i < contratosDistBrindes.length; i++) {
        if (contratosDistBrindes[i].id === action.contratoId) {
          contratosDistBrindes[i].distribuiuBrindes = action.status;
        }
      }
      return { ...state, todos: contratosDistBrindes };
    case 'STATUS_END_ENTREGA':
      let contratosEndEntrega = state.todos;
      for (let i = 0; i < contratosEndEntrega.length; i++) {
        if (contratosEndEntrega[i].id === action.contratoId) {
          contratosEndEntrega[i].enderecoPreenchido = action.status;
        }
      }
      return { ...state, todos: contratosEndEntrega };
    case 'STATUS_PERSONALIZACAO_LIBERADA':
      let contratosPersonalizacao = state.todos;
      for (let i = 0; i < contratosPersonalizacao.length; i++) {
        if (contratosPersonalizacao[i].id === action.contratoId) {
          contratosPersonalizacao[i].personalizacaoLiberada = action.status;
        }
      }
      return { ...state, todos: contratosPersonalizacao };
    case 'ALTERAR_CONTRATO':
      toast.success("Contrato atualizado com sucesso.");
      return { ...state, carregando: false, todos: state.todos.filter((contrato) => { return contrato.id !== action.contrato.id }).concat(action.contrato) };
    case 'REMOVER_CONTRATO':
      toast.success("Contrato removido com sucesso.", 5000);
      return { ...state, carregando: false, aguardando: state.aguardando.filter((contrato) => { return contrato.id !== action.id }) };
    case 'TRANSFERIR_CONTRATO':
      toast.success("Contrato tranferido com sucesso.", 5000);
      return { ...state, carregando: false, todos: state.todos.filter((contrato) => { return contrato.id !== action.contrato.id }).concat(action.contrato) };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ContratoReducer.js